import { ActivityParticipant, FeedbackRoundInfo, ParticipatedRole } from "PFTypes/activity_participant";
import { createContext, useContext } from "react";

import { FeedbackFormData } from "./form/feedback_form_context";

type FormSectionData = FeedbackFormData & { round?: number };

export type FeedbackEntry = {
  roleId: number;
  profileId: number;
};

type FeedbackContext = {
  selectedEntry: FeedbackEntry | undefined;
  setSelectedEntry: React.Dispatch<React.SetStateAction<FeedbackEntry | undefined>>;
  selectedRole: ParticipatedRole | undefined;
  selectedParticipant: ActivityParticipant | undefined;
  setCurrentFormData: React.Dispatch<React.SetStateAction<FeedbackFormData | null>>;
  currentFormData: FeedbackFormData | null;
  setActiveFeedbackRound: React.Dispatch<React.SetStateAction<FeedbackRoundInfo | null>>;
  activeFeedbackRound: FeedbackRoundInfo | null;
  setSavedForms: React.Dispatch<React.SetStateAction<Record<number, FeedbackFormData | null>>>;
  savedForms: Record<number, FormSectionData | null>;
};

export const FeedbackContext = createContext({} as FeedbackContext);

export const useFeedbackContext = () => useContext(FeedbackContext);
